import React from 'react';
import './VidGalleryContent.css';
import { Link } from 'react-router-dom';


const videoUrl = "https://www.youtube.com/embed/7oqcU7T4L3o?si=A3HHA_c43k0qQXbI";

// TODO: replace with actual Callistus product catalog + videos once finalized
// Using Callistus images/data as placeholders for now
const productCards = [
    {
        title: "Luzon Blinds",
        subtitle: "Callistus Luzon Blinds combine alternating sheer and solid fabric bands in a single shade.",
        image: "/Assets/VidGalleryImages/luzon-inspiration-17.webp",
        link: "/videos/luzon-blinds"
    },
    {
        title: "Colby Blinds by Callistus Window Fashion",
        subtitle: "Most Energy Efficient Blinds.",
        image: "/Assets/VidGalleryImages/colby-15.webp",
        link: "/videos/colby-blinds-by-callistus-window-fashion"
    },
    {
        title: "Callistus Panel Blinds",
        subtitle: "Make a statement and enhance your space with Callistus Panel blinds",
        image: "/Assets/VidGalleryImages/panel_thumb_video.webp",
        link: "/videos/callistus-panel-blinds"
    },
    {
        title: "Grayson Blinds",
        subtitle: "Grayson blinds gives you ultimate privacy with a view to the outside.",
        image: "/Assets/VidGalleryImages/Grayson-07.webp",
        link: "/videos/new-window-nice"
    },
    {
        title: "Wooden Venetian Blinds",
        subtitle: "Wooden Venetian blinds offers experience timeless luxury.",
        image: "/Assets/VidGalleryImages/wooden-inspiration-02.webp",
        link: "/videos/wooden-venetian"
    }
];

const operatingSystemCards = [
    {
        title: "Wooden Venetian Manual",
        subtitle: "Callistus Wooden Venetian Blinds add a timeless style to your windows.",
        image: "/Assets/VidGalleryImages/Wooden_thumb_video.webp",
        link: "/videos/wooden-venetian-manual"
    },
    {
        title: "Roller Blinds One Touch Up",
        subtitle: "Gently diffusing the light to create an astonishing ambiance Callistus Roller Blinds can enlighten any space with its colour, design and texture.",
        image: "/Assets/VidGalleryImages/Roller_thumb_video.webp",
        link: "/videos/roller-blinds-one-touch-up"
    },
    {
        title: "Colby Blinds Top Down Bottom Up (TDBU)",
        subtitle: "Most energy efficient blinds specifically engineered to provide beauty and energy efficiency in both cold and warm climates.",
        image: "/Assets/VidGalleryImages/Colby_thumb_video.webp",
        link: "/videos/colby-blinds-top-down-bottom-up-tdbu"
    },
    {
        title: "Patricia Blind Automation",
        subtitle: "Patricia Blinds are luxurious to look at and are the latest trendsetter in interior designing.",
        image: "/Assets/VidGalleryImages/Patricia_thumb_video.webp",
        link: "/videos/patricia-blind-automation"
    }
];

const VidGalleryContent = () => {
    return (
        <div className="Vid-gallery-pg">
            <div className="gallery-tabs">
                <Link to="/gallery" className="gallery-tab">Photos Gallery</Link>
                <Link to="/videos-gallery" className="gallery-tab active-tab">Videos Gallery</Link>
            </div>

            <div className="video-gallery">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Videos</h1>
                    <nav className="video-breadcrumb" style={{ margin: '4px 0 20px 0', fontSize: '14px', color: '#555', textAlign: 'left' }}>
                        <Link to="/" style={{ color: '#333', textDecoration: 'underline' }}>Home</Link>
                        <span style={{ color: '#777', margin: '0 6px' }}>&gt;</span>
                        <span>Videos Gallery</span>
                    </nav>
                </div>

                <div className="hero-video-wrapper">
                    <div className="hero-video">
                        <iframe
                            src={videoUrl}
                            title="Callistus Window Blinds"
                            frameBorder="0"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>

                <section className="section">
                    <h3 className="section-title">PRODUCT</h3>
                    <div className="card-grid">
                        {productCards.map((card, index) => (
                            <Link to={card.link} className="card" key={index}>
                                <img src={card.image} alt={card.title} />
                                <h3>{card.title}</h3>
                                <p>{card.subtitle}</p>
                            </Link>
                        ))}
                    </div>
                </section>

                <section className="section">
                    <h3 className="section-title">OPERATING SYSTEM</h3>
                    <div className="card-grid">
                        {operatingSystemCards.map((card, index) => (
                            <Link to={card.link} className="card" key={index}>
                                <img src={card.image} alt={card.title} />
                                <h3>{card.title}</h3>
                                <p>{card.subtitle}</p>
                            </Link>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default VidGalleryContent;